

export const fetchPackages = ({productId, currency, type = 'good'}) => ({
  method: 'GET',
  endpoint: `/integrations/stripe/products/${productId}/packages?currency=${currency}&type=${type}`,
});

export const fetchSkuById = (skuId) => ({
  method: 'GET',
  prefix: ' ',
  endpoint: `/integrations/stripe/skus/${skuId}`,
});

export const fetchPlanById = (planId) => ({
  method: 'GET',
  endpoint: `/integrations/stripe/plans/${planId}`,
});